export default {"src":"https://web.assets.prod.heycar.com/v6.600.1/_next/static/media/login.f4757e58.svg","height":85,"width":77,"blurWidth":0,"blurHeight":0};